/**
 * Патч кеша для variant-picker fetch запросов.
 * Перехватывает запросы с option_values= и section_id=section-rendering-product-card
 * и возвращает закешированный ответ если URL уже запрашивался.
 */
(function () {
  const cache = new Map();
  const originalFetch = window.fetch;

  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input instanceof Request ? input.url : String(input);

    // Кешируем только запросы вариантов
    const isVariantRequest =
      url.includes('option_values=') || url.includes('section_id=section-rendering-product-card');

    if (!isVariantRequest) {
      return originalFetch.apply(this, arguments);
    }

    // Если есть в кеше — возвращаем копию
    if (cache.has(url)) {
      return Promise.resolve(cache.get(url).clone());
    }

    // Иначе делаем запрос и кешируем
    return originalFetch.apply(this, [input, { ...init, signal: undefined }]).then((response) => {
      if (response.ok) {
        cache.set(url, response.clone());
      }
      return response;
    });
  };
})();
